export default __webpack_public_path__ + "static/media/quiz-challenge.600b02f7.jpg";